export default __webpack_public_path__ + "static/media/hair-6-5.8cb19386.svg";